import { render, staticRenderFns } from "./AddTabItem.vue?vue&type=template&id=37a812c8&"
import script from "./AddTabItem.vue?vue&type=script&lang=js&"
export * from "./AddTabItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports